import { CUSTOM_ICONS } from '@nexelem/icons';
import { useCallback } from 'react';
import { useCustomTranslation } from '../../../../hooks';
import { useProductionPlanQueryParams, GanttMode, AVAILABLE_QUERY_PARAMS } from '../hooks';
import { useConfig } from '@nexelem/config';
import { Toggle } from '@nexelem/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserHelmetSafety } from '@fortawesome/pro-light-svg-icons';

export const GanttModeToggle = () => {
  const { modules } = useConfig();
  const { t, tWrapper } = useCustomTranslation('products.productionPlan');

  const { queryParams, setQueryParams } = useProductionPlanQueryParams();

  const ganttMode = queryParams.mode;

  const onChangeView = useCallback(
    (value: string) => {
      const newQueryParams = [{ key: AVAILABLE_QUERY_PARAMS.mode, value }];
      setQueryParams(newQueryParams);
    },
    [setQueryParams],
  );

  if (!modules.production.workerModeView) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-s11-sb text-text-secondary uppercase">{tWrapper('mode')}</span>
      <Toggle.Root value={ganttMode} onChange={onChangeView}>
        <Toggle.Button StartIcon={<CUSTOM_ICONS.Gantt />} value={GanttMode.DEFAULT}>
          {t('common.default')}
        </Toggle.Button>
        <Toggle.Button StartIcon={<FontAwesomeIcon icon={faUserHelmetSafety} />} value={GanttMode.WORKER}>
          {tWrapper('worker')}
        </Toggle.Button>
      </Toggle.Root>
    </div>
  );
};
